import React, { useMemo } from 'react';
import { useSelector } from 'react-redux';
import { useHistory } from 'react-router-dom';
import { format } from 'date-fns';
import AssetsDetailsWrapper from '../components/assets-details-wrapper/assets-details-wrapper';
import LoadDocBtn from '../modules/load-doc-btn';
import { useAppDispatch } from '../store';
import { setSigningInfo, signCredit } from '../store/actions/operations-sign';
import { setOperationResult } from '../store/actions/sign-result';
import { RootState } from '../types';
import { downloadFile, getPdfFromBase64 } from '../utils/files/downloadFile';
import { useSign } from 'hooks';

const AssetsCreditSignContainer: React.FC = () => {
  const dispatch = useAppDispatch();
  const auth = useSelector((state: RootState) => state.auth.account);
  const companyInfo = useSelector(
    (state: RootState) => state.companiesInfo.companies
  );
  const doc = useSelector(
    (state: RootState) => state.operationsSign.data.credit.decisionDoc
  );
  const decisionHash = useSelector(
    (state: RootState) => state.operationsSign.data.credit.decisionHash
  );
  const decisionId = useSelector(
    (state: RootState) => state.operationsSign.data.credit.decisionId
  );
  const details = useSelector(
    (state: RootState) => state.operationsSign.data.credit.details
  );

  const history = useHistory();

  const onClose = () => history.push('/orders');

  const {
    certificatesList,
    selectedCertificate,
    signEntity,
    onUserSelectCertificate,
    usersCertificates,
  } = useSign();

  const currentCert = useMemo(() => {
    return usersCertificates.find(
      (certificate) => certificate.thumbprint === selectedCertificate?.value
    );
  }, [usersCertificates, selectedCertificate]);

  const onSubmit = async () => {
    if (currentCert && decisionHash && decisionId) {
      const { pdfSigned } = await signEntity(decisionHash);
      if (pdfSigned) {
        dispatch(
          setSigningInfo({
            thumbprint: currentCert.thumbprint,
            name: currentCert.issuerName,
            date: `с ${format(
              new Date(currentCert.validFrom),
              'dd/MM/yyyy'
            )} до ${format(new Date(currentCert.validTo), 'dd/MM/yyyy')}`,
          })
        );
        dispatch(
          signCredit({
            signature: pdfSigned,
            hash: decisionHash,
            operationId: decisionId,
            type: 'RECEIVING',
          })
        )
          .then((action) => {
            const resultStatus = action.meta.requestStatus === 'fulfilled';
            dispatch(
              setOperationResult({ name: 'credit', status: resultStatus })
            );
            history.push('/credit/sign-result');
          })
          .catch(() => {
            dispatch(setOperationResult({ name: 'credit', status: false }));
            history.push('/credit/sign-result');
          });
      }
    }
  };

  const getDecisionDocs = () => {
    const docs = [];

    if (doc) {
      docs.push(
        <LoadDocBtn
          title="Договор займа"
          onSpecDownload={() => {
            const resultBlob = getPdfFromBase64(doc);
            downloadFile(resultBlob, 'Договор займа.pdf', 'application/pdf');
          }}
        />
      );
    }
    return docs;
  };

  return (
    <AssetsDetailsWrapper
      creditInfo={details}
      isCredit
      selectedCert={selectedCertificate}
      isDisabled={currentCert === undefined}
      from={{
        name: 'Платформа',
        inn: '78945674356',
      }}
      to={
        companyInfo[auth.id]
          ? {
              name: companyInfo[auth.id].shortName,
              inn: companyInfo[auth.id].tin,
            }
          : undefined
      }
      options={certificatesList}
      onSubmit={onSubmit}
      onClose={onClose}
      onCertSelect={onUserSelectCertificate}
      docs={getDecisionDocs()}
    />
  );
};

export default AssetsCreditSignContainer;
